export default __webpack_public_path__ + "static/media/success.d9a76195.gif";